import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, object=auth
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("pmc_token");
    if (!token) {
      setUser(false);
      setChecked(true);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data.user))
      .catch(() => {
        localStorage.removeItem("pmc_token");
        setUser(false);
      })
      .finally(() => setChecked(true));
  }, []);

  const login = (token, u) => {
    localStorage.setItem("pmc_token", token);
    setUser(u);
  };

  const refresh = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data.user);
    } catch (e) {}
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("pmc_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checked, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
